import { doc } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import {
  addRatingToGeneralObject,
  addToDataRelatedArray,
} from "../firebase/fireFuncs";
import db from "../firebase/fireInit";
import { queryRelatedTypes } from "../firebase/fireQueries";

import { forArrayLength, objectToArray } from "../misc/helperfuncs";
import boxStore from "../stores/boxStore";
import MainStore from "../stores/MainStore";
import useHandleBoxTypes from "./useHandleBoxTypes";
import useHandlePlayerArrays from "./useHandlePlayerArrays";

const useHandleRelated = ({ object }) => {
  const { getPluralType } = useHandleBoxTypes();
  const [related, setRelated] = useState([]);
  const { relatedBoxTypes } = boxStore();
  const [removedRelations, setRemovedRelations] = useState([]);
  const { updateObject, findObjectById } = useHandlePlayerArrays();
  const { player } = MainStore();
  const { getBoxType } = useHandleBoxTypes();

  function addRemovedRelation(relatedObject) {
    setRemovedRelations([...removedRelations, relatedObject]);
  }

  useEffect(() => {
    if (object) {
      const boxType = getBoxType(object.type);
      setRelated(boxType.related.types);
    }
  }, [object]);

  function addReferenceToRelatedObjects() {
    forArrayLength(related, (r) => {
      // itterating through the related object arrays. r is the objectType

      object[r].forEach((relatedObject) => {
        addToDataRelatedArray(
          getPluralType,
          relatedObject.type,
          relatedObject.id,
          object.type,
          object.id,
          player.uid
        );

        findObjectById(relatedObject.id, relatedObject.type, onFound);

        function onFound(objects) {
          if (objects.saved) {
            const array = relatedObject[getPluralType(object.type)];

            if (!array.includes(object.id)) array.push(object.id);
            updateObject("saved", { ...relatedObject });
          }
        }
      });
    });
  }

  function handleRatings() {
    if (object.ratings.first.rating > 0) {
      addRatingToGeneralObject(
        getPluralType,
        object.type,
        object.id,
        "generalFirst",
        object.ratings.first.rating,
        player.uid
      );
    }
    if (object.ratings.second.rating > 0) {
      addRatingToGeneralObject(
        getPluralType,
        object.type,
        object.id,
        "generalSecond",
        object.ratings.second.rating,
        player.uid
      );
    }
    // upload ratings to firebase
  }

  return { addReferenceToRelatedObjects, addRemovedRelation, handleRatings };
};

export default useHandleRelated;
